import React, {useCallback, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Box, Button, Typography} from '@mui/material';
import {useNavigate, useParams} from 'react-router-dom';
import {adminDeletePlayerSession} from '../../api/playerSessionAPI';

interface Props {
  playerSessionId: number;
}

const DeletePlayerSession: React.FC<Props> = ({playerSessionId}) => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const {profileId, teamId, teamSessionId} = useParams();

  const [deleteInProgress, setDeleteInProgress] = useState(false);

  const handleDelete = useCallback(async () => {
    setDeleteInProgress(true);
    const confirmed = window.confirm(
      t('admin.deletePlayerSessionConfirm') as string,
    );
    if (confirmed) {
      const res = await adminDeletePlayerSession(playerSessionId);
      if (!res?.success) {
        window.alert(res?.error ?? t('admin.failedToDeletePlayerSession'));
        setDeleteInProgress(false);
        return;
      }

      // redirect to correct player sessions page
      if (teamId && teamSessionId) {
        navigate(`/teams/${teamId}/teamsessions/${teamSessionId}`);
      } else if (teamId && profileId) {
        navigate(`/teams/${teamId}/players/${profileId}/playersessions`);
      } else if (profileId) {
        navigate(`/family/children/${profileId}/playersessions`);
      } else {
        navigate('/playersessions');
      }
    }
  }, [t, playerSessionId, teamId, teamSessionId, profileId, navigate]);

  return (
    <Box sx={{my: 2}}>
      <Typography variant="h4" sx={{mb: 2}}>
        {t('admin.deletePlayerSession')}
      </Typography>
      <Button
        variant="outlined"
        onClick={handleDelete}
        disabled={deleteInProgress}>
        {t('general.delete')}
      </Button>
    </Box>
  );
};

export default DeletePlayerSession;
